module.exports = __webpack_public_path__ + "static/media/hotel-settings.bcc5e69d.svg";